export function LoadingTerminal({ title = "loading...", lines = [], actions = [], meta = null, className = "" }) {
  return (
    <div className={`loading-terminal ${className}`.trim()} aria-busy="true" aria-live="polite">
      <div className="loading-terminal__bar">
        <span className="loading-terminal__dot loading-terminal__dot--red" />
        <span className="loading-terminal__dot loading-terminal__dot--yellow" />
        <span className="loading-terminal__dot loading-terminal__dot--green" />
        <span className="loading-terminal__title">{title}</span>
      </div>

      <div className="loading-terminal__body">
        {lines.map((line, idx) => (
          <div
            key={line.key || idx}
            className={`loading-terminal__line loading-terminal__line--${line.variant || "text"}`}
            style={line.style}
          />
        ))}

        {actions.length > 0 && (
          <div className="loading-terminal__actions">
            {actions.map((action, idx) => (
              <div
                key={action.key || idx}
                className={`loading-terminal__button ${action.ghost ? "loading-terminal__button--ghost" : ""}`.trim()}
                style={action.style}
              />
            ))}
          </div>
        )}

        {meta && <div className="loading-terminal__meta">{meta}</div>}
      </div>
    </div>
  );
}

export function LoadingGrid({ count = 3, height = 220, className = "" }) {
  return (
    <div className={`loading-grid ${className}`.trim()}>
      {Array.from({ length: count }, (_, index) => (
        <div key={index} className="loading-grid__item skeleton" style={{ height }} />
      ))}
    </div>
  );
}